import React from "react";

import Slice  from './slice'
import DescriptionProject from './description'
import './projectVerbindung.css';

const ProjectsVerbindung = () => (

  <div className="verbindungContainer">

<Slice/>
<DescriptionProject/>

</div>
);
export default ProjectsVerbindung;



// WEBPACK FOOTER //
// ./src/projects/Monucks/projectsVerbindung.js